import { Input, Directive, HostBinding } from '@angular/core';

@Directive({
    selector: '[layout]'
})

export class LayoutDirective {
    @Input() private layout: string;
    @HostBinding('style.display') private display = 'flex';

    @HostBinding('style.flex-direction')
    get direction() {
        return (this.layout === 'column') ? 'column' : 'row';
    }
}
@Directive({
    selector: '[flex]'
})
export class FlexDirective {
    @Input() private shrink: number = 1;
    @Input() private grow: number = 1;
    @Input() private flex: string;

    @HostBinding('style.flex')
    get style() {
        let basis = '100%';
        if (this.flex === 'auto') {
            basis = 'auto';
        } else if (this.flex !== '') {
            basis = this.flex + '%';
        }
        return `${this.grow} ${this.shrink} ${basis}`;
    }
}

@Directive({
    selector: '[flex-wrap]'
})
export class FlexWrapDirective {
    @HostBinding('style.flex-wrap')
    get style() {
        return `wrap`;
    }
}

@Directive({
    selector: '[layout-align]'
})
export class LayoutAlignDirective {
    @Input('layout-align') private align: string;

    @HostBinding('style.display') private display = 'flex';

    @HostBinding('style.justify-content')
    get horizontal() {
        let horizontalAlign = this.align.split(" ")[0];
        if (horizontalAlign === 'start') {
            return 'flex-start';
        } else if (horizontalAlign === 'end') {
            return 'flex-end';
        } else if (horizontalAlign === 'center') {
            return 'center';
        } else if (horizontalAlign === 'space-around') {
            return 'space-around';
        } else if (horizontalAlign === 'space-between') {
            return 'stretch';
        }
        return 'none';
    }

    @HostBinding('style.align-items')
    get verticalBis() {
        let horizontalAlign = this.align.split(" ")[1];
        if (horizontalAlign === 'start') {
            return 'flex-start';
        } else if (horizontalAlign === 'end') {
            return 'flex-end';
        } else if (horizontalAlign === 'center') {
            return 'center';
        } else if (horizontalAlign === 'stretch') {
            return 'stretch';
        }
        return 'none';
    }

    @HostBinding('style.align-content')
    get vertical() {
        let horizontalAlign = this.align.split(" ")[1];
        if (horizontalAlign === 'start') {
            return 'flex-start';
        } else if (horizontalAlign === 'end') {
            return 'flex-end';
        } else if (horizontalAlign === 'center') {
            return 'center';
        } else if (horizontalAlign === 'stretch') {
            return 'stretch';
        }
        return 'none';
    }
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/VyQQATNu/0/groupe-dev/nm17/node_modules/nm-socle-application/app/directives/layout-angular-material.directive.ts